<div class="edit-vendor-contact"
  [attr.aria-busy]="isSaving"
     data-testid="edit-vendor-contact">

  <div class="form-field">

    <label for="contact-email"
           class="field-label body-md-bold"
           [class.label-invalid]="!!emailError">
    @if (vendorName) {
      <span class="vendor-name-display body-md-bold"
            data-testid="edit-vendor-contact-vendor-name">
        Vendor: {{ vendorName }}
      </span>
    }
    </label>
    <input id="contact-email"
           type="email"
           class="email-input body-md-regular"
           [class.input-invalid]="!!emailError"
           [value]="emailValue()"
           (input)="emailValue.set($any($event.target).value)"
           placeholder="email@example.com"
           autocomplete="off"
           data-testid="edit-vendor-contact-email-input" />
    @if (emailError) {
      <app-input-error data-testid="edit-vendor-contact-email-error">{{ emailError }}</app-input-error>
    }
  </div>

  <div class="contact-actions">
    <p-button label="Save Contact"
              type="button"
              [disabled]="isSaving"
              [loading]="isSaving && loadingAction === 'save'"
              styleClass="bqa-primary-btn p-fullwidth-button"
              (onClick)="onSave()"
              data-testid="edit-vendor-contact-save-btn" />

    @if (mode === 'add') {
      <p-button label="Save and Add Another"
                type="button"
                [outlined]="true"
                [disabled]="isSaving"
                [loading]="isSaving && loadingAction === 'saveAndAddAnother'"
                styleClass="bqa-primary-btn p-fullwidth-button body-lg-regular"
                (onClick)="onSaveAndAddAnother()"
                data-testid="edit-vendor-contact-save-add-btn" />
    }

    @if (mode === 'edit') {
      <p-button label="Delete Address"
                type="button"
                severity="danger"
                [outlined]="true"
                [disabled]="isSaving"
                [loading]="isSaving && loadingAction === 'delete'"
                styleClass="bqa-danger-btn p-fullwidth-button"
                (onClick)="onDelete()"
                data-testid="edit-vendor-contact-delete-btn" />
    }

    <p-button label="Cancel"
              type="button"
              severity="secondary"
              [text]="true"
              [disabled]="isSaving"
              styleClass="bqa-secondary-btn p-fullwidth-button"
              (onClick)="onCancel()"
              data-testid="edit-vendor-contact-cancel-btn" />
  </div>

</div>
